import { USCurrency } from 'components/ReusableComponents/FormattedPrice'

import styles from './TotalCard.module.scss'

const TotalCard = ({ invoiceDetails, taxRate }) => {
  const { totalTax, totalBilledAmount, totalFixedServices, totalMessageFees } =
    invoiceDetails

  return (
    <div className={styles.totalCard}>
      <div className={styles.totalCardRow}>
        <div className={styles.totalCardName}>Subtotal</div>
        <div className={styles.totalCardValue}>
          <USCurrency withCode>{totalFixedServices + totalMessageFees}</USCurrency>
        </div>
      </div>
      <div className={styles.totalCardRow}>
        <div className={styles.totalCardName}>{taxRate.toString()}% sales tax</div>
        <div className={styles.totalCardValue}>
          <USCurrency withCode>{totalTax}</USCurrency>
        </div>
      </div>
      <div className={styles.totalCardRowHighlighted}>
        <div className={styles.totalCardName}>Total billed</div>
        <div className={styles.totalCardValue}>
          <USCurrency withCode>{totalBilledAmount}</USCurrency>
        </div>
      </div>
    </div>
  )
}

export default TotalCard
